(() => {
  angular.module('app').component('hostCorporatesFinanceManagementBankingComponent', {
    templateUrl: require('./banking.component.html'),
    controller: CorporateBankingController,
    controllerAs: 'vm',
    bindings: {
      corporateId: '<',
    },
  });

  CorporateBankingController.$inject = [
    'abp.services.app.corporate',
    'Hms.MultiTenancy.TenantVirtualAccountGenerationMode',
  ];

  function CorporateBankingController(corporateSvc, enumTenantVirtualAccountGenerationMode) {
    const vm = this;
    vm.loading = 0;
    vm.bankingDetails = null;

    vm.enums = {};
    vm.enums.tenantVirtualAccountGenerationMode = enumTenantVirtualAccountGenerationMode;

    // Get banking details of corporate

    vm.$onChanges = () => {
      if (vm.corporateId) getBankingDetails(vm.corporateId);
    };

    function getBankingDetails(corporateId) {
      vm.loading += 1;
      corporateSvc
        .getCorporateForEdit({
          id: corporateId,
        })
        .success((data) => {
          vm.bankingDetails = data.finance;
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }
  }
})();
